import { render, staticRenderFns } from "./CommandeDetail.vue?vue&type=template&id=2d0ff784&scoped=true&"
import script from "./CommandeDetail.vue?vue&type=script&lang=js&"
export * from "./CommandeDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommandeDetail.vue?vue&type=style&index=0&id=2d0ff784&lang=scss&scoped=true&"
import style1 from "./CommandeDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0ff784",
  null
  
)

export default component.exports